<div class="container-fluid home-wrapper">
    <mat-toolbar class="landing-topbar">
        <mat-toolbar-row>
            <img src="/assets/images/long-logo-tp.svg" alt="logo">
        </mat-toolbar-row>
    </mat-toolbar>
    <div class="portal-card-wrapper">
        <mat-card>
            <p class="portal-card-title">{{'generic_portal_card_title' | translate}}</p>
            <p class="portal-card-description">{{'generic_portal_card_description' | translate}}</p>
            <div class="portal-card-link">
                <div class="portal-card-url">partner-portal.operations.transporeon.com/</div>
                <supplystack-input-2 style="width: 33%">
                    <input type="text" [(ngModel)]="portalName" placeholder="Your workspace"
                        (keyup.enter)="getPortalAndNavigate()">
                </supplystack-input-2>
            </div>
            <button mat-button class="portal-find-button" (click)="getPortalAndNavigate()">
                Continue
            </button>
        </mat-card>
    </div>
</div>
<mat-toolbar class="normal-footer">
    <mat-toolbar-row>
        <span class="title" for="title">©{{customerName}}</span>
        <a class="links" target="_blank" rel="noopener noreferrer" [href]="termsLink">{{'generic_terms_and_conditions' |
            translate}}</a>
        <a class="links" target="_blank" rel="noopener noreferrer" [href]="privacyLink">{{'generic_privacy_policy' |
            translate}}</a>
        <span class="example-spacer"></span>
        <div style="width: 164px; margin-right: 16px;">
            <supplystack-language-select (setOptionEvent)=" changeLanguage($event)">
            </supplystack-language-select>
        </div>
        <span class="powered">{{'generic_powered_by' | translate}}</span>
        <div class="powered-wrapper">
            <a target="_blank" rel="noopener noreferrer" href="https://transporeon.com/" class="rotating-icon">
                <img src="/assets/images/tp-logo.svg" style="height: 36px;" alt="powered-logo">
            </a>
        </div>
    </mat-toolbar-row>
</mat-toolbar>
